import React, { Fragment, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Box, Grid } from '@material-ui/core'

import {
  requestResetPassword,
  initForgotPasswordForm,
} from 'Reducers/Auth/actions'
import AuthWrapper from '../AuthWrapper'
import SubmitButton from '../../../Components/Form/SubmitButton'
import Link from '../../../Components/Link'
import { PATHS } from '../../../Config/Routing/paths'
import Input from '../../../Components/Inputs/Input'
import PasswordResetIllustration from '../../../Assets/Images/icons/PasswordResetIllustration'
import { useWrappedPosthog } from '../../../Components/PostHogProvider/hooks'

const ForgotPassword = ({ classes, history }) => {
  const posthog = useWrappedPosthog()

  const [fields, setFields] = useState({
    email: { value: '', error: true, additionalError: false },
  })
  const [disabled, setDisabled] = useState(true)
  const dispatch = useDispatch()

  const formSubmitted = useSelector(state => state.auth.formSubmitted)
  const errorMessage = useSelector(state => state.auth.errorMessage)

  useEffect(() => {
    dispatch(initForgotPasswordForm())
  }, [])

  useEffect(() => {
    const isFieldsHasError = Object.values(fields).some(({ error }) => error)

    if (isFieldsHasError) {
      setDisabled(true)
    } else {
      setDisabled(false)
    }
  }, [fields])

  const onChange = type => (value, error) => {
    setFields(prev => ({
      ...prev,
      [type]: {
        value,
        error: !value || !!error,
      },
    }))
  }

  const onSubmit = () => {
    if (posthog) {
      posthog.capture('Reset Password', {
        'event_category': 'Login',
      })
    }
    dispatch(requestResetPassword(fields.email.value))
  }

  return (
    <AuthWrapper>
      <Grid container spacing={4}>
        <Grid
          container
          item
          xs={12}
          md={6}
          alignItems="center"
          justifyContent="center"
          className="h-100"
        >
          <Grid
            container
            item
            xs={12}
            alignItems="center"
            justifyContent="center"
            className={'content has-large-padding h-100'}
          >
            <Box className="content-inner">
              {formSubmitted ? (
                <Fragment>
                  <h1>
                    Password request sent to {fields.email.value}
                    <br />
                    Please check your inbox.
                  </h1>
                  <div className={'link text-center'}>
                    Back to <Link text="Log in" to={PATHS.main.login} />
                  </div>
                </Fragment>
              ) : (
                <Fragment>
                  <h1>
                    Enter your email and receive a link to create a new
                    password:
                  </h1>
                  <Input
                    label="Email address"
                    value={fields.email.value}
                    additionalError={fields.email.additionalError}
                    onChange={onChange('email')}
                    required
                    email
                    cypress_id={'emailInput'}
                  />
                  <SubmitButton
                    className={'buttonNext'}
                    onClick={onSubmit}
                    disabled={disabled}
                    cypress_id={'sendPasswordResetBtn'}
                  >
                    <span>Send password reset link</span>{' '}
                  </SubmitButton>
                  {errorMessage ? (
                    <div className={'error'}>{errorMessage}</div>
                  ) : null}
                  <div className={'link text-center'}>
                    Back to <Link text="Log in" to={PATHS.main.login} />
                  </div>
                </Fragment>
              )}
            </Box>
          </Grid>
        </Grid>
        <Grid
          container
          item
          xs={12}
          md={6}
          justifyContent="center"
          alignItems="center"
          direction="column"
        >
          <PasswordResetIllustration className={'illustration'} />
        </Grid>
      </Grid>
    </AuthWrapper>
  )
}

export default ForgotPassword
